import { render, staticRenderFns } from "./criteria.vue?vue&type=template&id=8efa610c"
import script from "./criteria.vue?vue&type=script&lang=js"
export * from "./criteria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports